import React from 'react';
import Typography from '@mui/material/Typography';
import { LoadingButton } from '@mui/lab';

type Props = {
    title: string;
    onClick: any;
    startIcon?: JSX.Element | string | undefined;
    endIcon?: JSX.Element | string | undefined;
    sx?: object | undefined;
    sxTitle?: object | undefined;
    fullWidth?: false | boolean;
    disabled?: false | boolean;
    loading?: false | boolean;
    loadingPosition?: 'start' | 'end' | 'center';
};

const LoadingButtonGeneral = ({
    title,
    onClick,
    startIcon,
    endIcon,
    sx,
    sxTitle,
    fullWidth,
    disabled,
    loading,
    loadingPosition,
}: Props) => {
    return (
        <>
            <LoadingButton
                loading={loading}
                type="submit"
                fullWidth={fullWidth}
                onClick={onClick}
                variant="contained"
                startIcon={startIcon !== undefined ? startIcon : null}
                endIcon={endIcon !== undefined ? endIcon : null}
                loadingPosition={loadingPosition}
                disabled={disabled}
                style={{ backgroundColor: disabled ? '#696969' : '' }}
                sx={sx}
            >
                <Typography
                    color="secondary"
                    component="div"
                    sx={sxTitle || { fontSize: { lg: 12, md: 10.5, xs: 9 } }}
                >
                    {title}
                </Typography>
            </LoadingButton>
        </>
    );
};

export default LoadingButtonGeneral;
